/**
 * Check if the "command" modifier key is pressed in a keyboard event.
 * On Mac this is Cmd (metaKey), on Windows/Linux this is Ctrl (ctrlKey).
 * This provides cross-platform support for keyboard shortcuts.
 *
 * @param event - The keyboard event to check
 * @returns true if the command modifier key is pressed
 */
export const isCommandKeyPressed = (event: KeyboardEvent): boolean => {
  return event.metaKey || event.ctrlKey;
};
